import { message } from 'antd';
import axios from 'axios';
import config from '../config';

/**
 * battleship-cloud gateway 和 数据引擎（dataengine）接口专用 HTTP 客户端。
 * 与 ucenterHttp、问卷 request 分离，避免 baseURL / 拦截器互相污染。
 */
class HttpClient {
    constructor() {
        this.axiosInstance = axios.create({
            timeout: 30000,
            baseURL: config.GATEWAY_API_PREFIX,
        });

        this.axiosInstance.interceptors.response.use(
            resp => {
                if (resp.status === 200) {
                    const data = resp.data;

                    switch (data.status_code) {
                        case 200:
                            return data.data;
                        case 400:
                            message.error(data.message);
                            break;
                        case 401:
                            break;
                        case 403:
                            break;
                        default:
                            return data;
                    }
                } else {
                    return Promise.reject(resp);
                }
            },
            err => {
                if (err && err.response) {
                    // TODO
                }
                return Promise.reject(err);
            },
        );
    }

    async get(url, params = {}) {
        return await this.axiosInstance.get(url, { params: this.prepareParams(params) });
    }

    async post(url, data, requestConfig = {}) {
        return await this.axiosInstance.post(url, data, requestConfig);
    }

    prepareParams(params) {
        const newParams = {};

        if (params) {
            for (const key in params) {
                if (params[key] === null || params[key] === undefined) {
                    continue;
                }
                newParams[key] = params[key];
            }
        }

        return newParams;
    }
}

export default new HttpClient();
